import { isServer } from '@vue-storefront/core/helpers'

/**
 * Formats product data for Klaviyo "Viewed Product" event
 */
export const getKlaviyoViewedProduct = (item: any) => {
  try {
    if (!item) return null

    const absoluteUrl = window.location.href

    const categories = item.category && item.category.length > 0
      ? item.category.map((cat: any) => cat.name)
      : []

    const price = item.price || item.price_incl_tax || item.final_price || item.finalPrice || 0
    const finalPrice = item.final_price || item.finalPrice || price
    const priceValue = String(price).replace(',', '')

    const result: any = {
      ProductID: item.id,
      Name: item.name,
      SKU: item.sku,
      URL: absoluteUrl,
      Price: price,
      FinalPrice: finalPrice,
      Categories: categories,
      $value: priceValue
    }

    if (item.image) {
      result.ImageURL = item.image
    } else if (item.thumbnail) {
      result.ImageURL = item.thumbnail
    } else if (item.small_image) {
      result.ImageURL = item.small_image
    }

    return result
  } catch (error) {
    console.debug('Klaviyo getViewedProduct error:', error)
    return null
  }
}

/**
 * Formats product data for Klaviyo "ViewedItem" event
 */
export const getKlaviyoViewedItem = (item: any) => {
  try {
    if (!item) return null

    const absoluteUrl = window.location.href

    const categories = item.category && item.category.length > 0
      ? item.category.map((cat: any) => cat.name)
      : []

    const price = item.price || item.price_incl_tax || item.final_price || item.finalPrice || 0

    const result: any = {
      Title: item.name,
      ItemId: item.id,
      Url: absoluteUrl,
      Categories: categories,
      Metadata: {
        Price: price
      }
    }

    if (item.image) {
      result.ImageURL = item.image
    } else if (item.thumbnail) {
      result.ImageURL = item.thumbnail
    } else if (item.small_image) {
      result.ImageURL = item.small_image
    }

    return result
  } catch (error) {
    console.debug('Klaviyo getViewedItem error:', error)
    return null
  }
}

/**
 * Tracks product view events in Klaviyo
 */
export const trackKlaviyoProductView = (product: any) => {
  if (isServer) return

  try {
    const win = window as any
    if (!win.klaviyo) return

    const klaviyo = win.klaviyo
    const viewedProduct = getKlaviyoViewedProduct(product)
    const viewedItem = getKlaviyoViewedItem(product)

    if (viewedProduct) {
      klaviyo.push(['track', 'Viewed Product', viewedProduct])
    }
    if (viewedItem) {
      klaviyo.push(['trackViewedItem', viewedItem])
    }
  } catch (error) {
    // Silently fail if Klaviyo is not available or tracking fails
    console.debug('Klaviyo tracking error:', error)
  }
}

/**
 * Identifies the user in Klaviyo and tracks subscription
 */
export const subscribeToKlaviyo = (email: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if (isServer) {
      resolve(false)
      return
    }

    try {
      const win = window as any
      if (!win.klaviyo) {
        resolve(false)
        return
      }

      const klaviyo = win.klaviyo

      // Identify the user
      klaviyo.push(['identify', {
        $email: email
      }, () => {
        // Track specific event for flows
        klaviyo.push(['track', 'Newsletter Subscribed', {
          $email: email
        }, () => {
          resolve(true)
        }])
      }])
    } catch (error) {
      console.debug('Klaviyo subscription error:', error)
      resolve(false)
    }
  })
}
